import * as React from 'react';
import * as style from './PromoCompilationsLayout.css';

export const PromoCompilationsLayout: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return (
    <div className={style['container']} data-testid="PromoCompilationsLayout">
      {children}
    </div>
  );
};
